import SmallPopupTemplate from "components/templates/modal/small/SmallPopupTemplate";

type Props = {
  title: string;
  subTitle?: string;
  onModal: () => void;
  children: React.ReactNode;
};

export default function BreakdownModal({
  title,
  subTitle,
  onModal,
  children,
}: Props): JSX.Element {
  return (
    <SmallPopupTemplate
      title={title}
      subTitle={subTitle}
      onModal={onModal}
      onClick={onModal}
      confirmLabel="Close"
      className="breakdown-modal"
    >
      {children}
    </SmallPopupTemplate>
  );
}
